import { ArgumentNullException } from '../../../../utility/exception/argument-null.exception';
import { PrimitiveValueObject } from '../../../../utility/model/primitive-value-object.model';

export class SlackOAuthBotId extends PrimitiveValueObject<string> {
  static create(value: string): SlackOAuthBotId {
    return new SlackOAuthBotId(value);
  }
}
